import React, { useContext } from 'react';
import {
  elementType,
  string,
  oneOfType,
  arrayOf,
  element,
  node,
  func,
  bool,
} from 'prop-types';
import { AppContext } from 'src/context';
import {
  StyledLink,
  NavLink,
} from 'src/components/common/styledComponents/styledLink';
import { ONBOARDING_PAGE_URL } from 'src/constants/urlConstants';
import { ONBOARDING_STARTED_AGENCY_STATUS } from 'src/constants/agency';
import { useRedirect } from './useRedirect';

const SmartLink = React.forwardRef(
  (
    {
      to,
      children,
      className,
      activeClassName,
      isActive,
      onClick,
      dataTest,
      exact,
      external = false,
    },
    ref,
  ) => {
    const redirect = useRedirect(to);
    const {
      store: { agency },
    } = useContext(AppContext);

    if (redirect) {
      return (
        <StyledLink
          href={redirect}
          className={className}
          onClick={onClick}
          data-test={dataTest}
          ref={ref}
        >
          {children}
        </StyledLink>
      );
    }

    const linkProps = {
      className,
      activeClassName,
      onClick,
      isActive,
      'data-test': dataTest,
      ref,
      exact,
    };

    if (agency.status === ONBOARDING_STARTED_AGENCY_STATUS) {
      return (
        <NavLink to={ONBOARDING_PAGE_URL} {...linkProps}>
          {children}
        </NavLink>
      );
    }

    if (external) {
      return (
        <StyledLink href={to} {...linkProps}>
          {children}
        </StyledLink>
      );
    }

    return (
      <NavLink to={to} {...linkProps}>
        {children}
      </NavLink>
    );
  },
);

SmartLink.propTypes = {
  to: string,
  children: oneOfType([
    elementType,
    arrayOf(elementType),
    element,
    arrayOf(node),
  ]).isRequired,
  className: string,
  activeClassName: string,
  isActive: func,
  onClick: func,
  dataTest: string,
  exact: bool,
  external: bool,
};

SmartLink.displayName = 'SmartLink';

export { SmartLink };
